import React, { useEffect, useState } from "react";
import DTOCreateTaskModal from "./DTOCreateTaskModal";
import CreateTaskModalPresenter from "./CreateTaskModalPresenter";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const CreateTaskModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  return (
    <div>
      <DTOCreateTaskModal />

      <CreateTaskModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={trans}
      />
    </div>
  );
};

export default CreateTaskModalController;
